import React from 'react';
export const FooterCopyright = () => (React.createElement("footer", { className: 'bg-primary' },
    React.createElement("div", { className: 'container-fluid p-3' },
        React.createElement("p", { className: 'm-0 text-center text-white' },
            "\u00A9 Tessi ",
            new Date().getFullYear()))));
